const ICONS = {
  glass: '<svg aria-hidden="true" viewBox="0 0 32 32"><path d="M16 27V16M8 27h16M10 16c0-6 3-10 6-12 3 2 6 6 6 12-2 2-4 3-6 3s-4-1-6-3Z"/><path d="m16 4-2 7 2 8 2-8-2-7ZM10 16l6-5 6 5"/></svg>',
  hand: '<svg aria-hidden="true" viewBox="0 0 32 32"><path d="M5 23c3-1 4-5 7-5 2 0 3 2 5 2 3 0 4-3 6-3 2 0 3 2 3 4 0 4-5 6-10 6H9c-2 0-3-1-4-4Z"/><path d="M17 12c0-2 2-4 4-4s4 2 4 4-2 4-4 4-4-2-4-4Z"/></svg>',
  room: '<svg aria-hidden="true" viewBox="0 0 32 32"><path d="M4 15 16 5l12 10v12H4V15Z"/><path d="M12 27V18h8v9"/></svg>',
  bulb: '<svg aria-hidden="true" viewBox="0 0 32 32"><path d="M10 14a6 6 0 1 1 12 0c0 4-3 5-4 8h-4c-1-3-4-4-4-8Z"/><path d="M13 25h6M14 28h4"/></svg>',
};

function fittingFrom(table) {
  for (const row of table.querySelectorAll('tr')) {
    const cells = row.querySelectorAll('th, td');
    if (cells.length < 2) continue;
    const key = cells[0].textContent.replace(/\s+/g, ' ').trim().toLowerCase();
    const value = cells[1].textContent.replace(/\s+/g, ' ').trim();
    if (
      value &&
      /(bulb|lamp)/.test(key) &&
      (/(fitting|base|socket|type|holder)/.test(key) || /^(light )?bulbs?$/.test(key)) &&
      !/unknown|n\/a|not specified/i.test(value)
    ) {
      return value.toUpperCase();
    }
  }
  return '';
}

function point(icon, text) {
  const item = document.createElement('div');
  item.className = 'tiffany-mobile-point';
  item.innerHTML = `<span class="tiffany-mobile-point__icon">${ICONS[icon]}</span>`;
  const copy = document.createElement('span');
  copy.textContent = text;
  item.append(copy);
  return item;
}

function setBuyNowState(section, variant) {
  const link = section.querySelector('[data-tiffany-buy-now-link]');
  if (!link) return;
  const id = variant?.id ? String(variant.id) : '';
  const available = variant?.available === true;
  const source = section.parentElement?.querySelector('[data-tiffany-buy-now-source]');
  const root = window.Shopify?.routes?.root || source?.dataset.rootUrl || '/';
  if (id && available) {
    link.href = `${root}cart/${id}:1?checkout`;
    link.removeAttribute('aria-disabled');
    link.removeAttribute('tabindex');
    link.textContent = 'Buy now';
  } else {
    link.removeAttribute('href');
    link.setAttribute('aria-disabled', 'true');
    link.setAttribute('tabindex', '-1');
    link.textContent = 'Sold out';
  }
  const stock = section.querySelector('[data-tl-stock]');
  if (stock && variant?.price !== undefined) {
    stock.textContent = available ? 'In stock' : 'Sold out';
  }
  const saving = section.querySelector('[data-tl-saving]');
  if (saving && variant?.price !== undefined) {
    const amount = Number(variant.compare_at_price || 0) - Number(variant.price);
    saving.hidden = amount <= 0;
    if (amount > 0) {
      saving.textContent = `Save ${new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency', currency: source?.dataset.currency || 'GBP',
      }).format(amount / 100)}`;
    }
  }
}

function disclosure(label, content) {
  const element = document.createElement('details');
  element.className = 'tl-product-disclosure';
  const heading = document.createElement('summary');
  heading.textContent = label;
  const body = document.createElement('div');
  body.className = 'tl-product-disclosure__body';
  body.append(content);
  element.append(heading, body);
  return element;
}

function policyContent(text, url, label) {
  const content = document.createElement('p');
  content.append(`${text} `);
  const link = document.createElement('a');
  link.href = url;
  link.textContent = label;
  content.append(link);
  return content;
}

function organiseDescription(description, details) {
  const accordion = document.createElement('section');
  accordion.className = 'tl-product-information';
  accordion.setAttribute('aria-label', 'Product information');
  const intro = document.createElement('div');
  intro.className = 'tl-product-craft';
  intro.innerHTML = '<h2>Handcrafted stained glass</h2><p>Individual pieces of coloured glass, carefully assembled by hand.</p><p class="tl-perfect-for"><strong>Perfect for</strong> Living rooms · Reading corners · Bedrooms</p>';
  accordion.append(intro);
  const highlights = document.createElement('section');
  highlights.className = 'tiffany-mobile-points tl-shared-highlights';
  highlights.setAttribute('aria-label', 'Lamp highlights');
  const specificationTable = description.querySelector('table');
  const fitting = specificationTable ? fittingFrom(specificationTable) : '';
  highlights.append(
    point('glass', 'Beautiful detailed stained glass'),
    point('hand', 'Individual handcrafted pieces'),
    point('room', 'Ideal for any room'),
    point('bulb', fitting ? `Compatible with ${fitting} bulb` : 'Bulb compatibility: see specifications')
  );
  accordion.append(highlights);

  const dimensions = document.createElement('table');
  const electrical = document.createElement('table');
  dimensions.setAttribute('aria-label', 'Dimensions and materials');
  electrical.setAttribute('aria-label', 'Bulb and electrical specifications');
  for (const table of description.querySelectorAll('table')) {
    for (const row of [...table.querySelectorAll('tr')]) {
      const key = row.querySelector('th, td')?.textContent || '';
      row.removeAttribute('style');
      for (const cell of row.querySelectorAll('td, th')) {
        cell.removeAttribute('style');
        cell.removeAttribute('height');
      }
      if (/bulb|socket|fitting|watt|voltage|dimm|electri|power/i.test(key)) {
        electrical.append(row);
      } else {
        dimensions.append(row);
      }
    }
    table.remove();
  }
  // Move, rather than rewrite, the complete merchant-supplied description.
  const original = document.createElement('div');
  original.className = 'tl-original-description';
  original.append(...description.childNodes);
  accordion.append(disclosure('Description', original));
  const specifications = [];
  if (dimensions.children.length) specifications.push(disclosure('Dimensions', dimensions));
  accordion.append(...specifications);
  if (electrical.children.length) accordion.append(disclosure('Bulb & Electrical', electrical));
  const shipping = details.querySelector('.tl-purchase-promises a')?.href || '/policies/shipping-policy';
  const returns = details.querySelector('.tl-purchase-promises a:last-child')?.href || '/policies/refund-policy';
  accordion.append(
    disclosure('Delivery', policyContent('Free UK delivery. See our delivery policy for dispatch times and any location restrictions.', shipping, 'Delivery information')),
    disclosure('Returns', policyContent('Free 30-day returns, subject to our returns policy.', returns, 'Returns information'))
  );
  description.replaceWith(accordion);
  const section = details.closest('.product-information');
  const media = section?.querySelector('.product-information__media');
  if (media) {
    const desktopContent = document.createElement('section');
    desktopContent.className = 'tl-desktop-image-details';
    desktopContent.setAttribute('aria-label', 'Lamp highlights and specifications');
    desktopContent.hidden = true;
    media.append(desktopContent);
    const placements = [highlights, ...specifications].map((element) => {
      const marker = document.createComment('Mobile product information position');
      element.before(marker);
      return { element, marker, mobileOpen: element.open };
    });
    const desktop = window.matchMedia('(min-width: 750px)');
    const placeInformation = () => {
      desktopContent.hidden = !desktop.matches;
      placements.forEach((placement) => {
        const { element, marker } = placement;
        if (desktop.matches) {
          placement.mobileOpen = element.open;
          desktopContent.append(element);
          if (element instanceof HTMLDetailsElement) element.open = true;
        } else {
          marker.after(element);
          if (element instanceof HTMLDetailsElement) element.open = placement.mobileOpen;
        }
      });
    };
    placeInformation();
    desktop.addEventListener('change', placeInformation);
    const unload = (event) => {
      if (!event.target.contains(section)) return;
      desktop.removeEventListener('change', placeInformation);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  }
}

function initialise(section) {
  if (section.dataset.tiffanyInitialised === 'true') return;
  section.dataset.tiffanyInitialised = 'true';

  const details = section.querySelector('.product-details');
  const source = section.parentElement?.querySelector('[data-tiffany-buy-now-source]');
  const initialId = source?.dataset.variantId;
  const initialAvailable = source?.dataset.variantAvailable === 'true';
  let variantChangeVersion = 0;
  if (details && source) {
    const wrap = document.createElement('div');
    wrap.className = 'tiffany-buy-now-wrap';
    wrap.append(...source.childNodes);
    const titleGroup = details.querySelector(':scope > .group-block');
    const price = details.querySelector('product-price');
    if (price) {
      price.insertAdjacentElement('afterend', wrap);
    } else {
      titleGroup?.insertAdjacentElement('beforebegin', wrap);
    }
    setBuyNowState(section, { id: initialId, available: initialAvailable });
  }

  const title = details?.querySelector('[class*="__text_xrnftG"] h1');
  const brand = details?.querySelector('[class*="__text_xrnftG"] p');
  if (brand) {
    brand.classList.add('tiffany-product-brand');
    brand.textContent = 'By Belofay';
    title?.insertAdjacentElement('afterend', brand);
  }
  if (title && source?.dataset.displayTitle) title.textContent = source.dataset.displayTitle;
  if (title) {
    const storeTrust = document.createElement('a');
    storeTrust.className = 'tl-title-trust';
    storeTrust.href = 'https://www.trustpilot.com/review/tiffanylighthouse.co.uk';
    storeTrust.target = '_blank';
    storeTrust.rel = 'noopener';
    storeTrust.textContent = 'Store rated 4.4/5 on Trustpilot';
    (brand || title).insertAdjacentElement('afterend', storeTrust);
  }

  const description = details?.querySelector('[class*="__text_aEtTtq"]');
  if (description && details) organiseDescription(description, details);

  section.addEventListener('shopify:product:select', (event) => {
    const promise = event.promise;
    if (!promise) return;
    const version = ++variantChangeVersion;
    promise.then(({ detail }) => {
      if (version !== variantChangeVersion) return;
      if (!detail?.resource) return setBuyNowState(section, null);
      setBuyNowState(section, detail.resource);
    });
  });
}

function initialiseAll(root = document) {
  root.querySelectorAll('.product-information').forEach(initialise);
}

document.addEventListener('DOMContentLoaded', () => initialiseAll());
document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));